import React from "react";

import { ActiveFieldType } from "../../../../../../../types/apop";

type RadioButtonProps = {
  eventChangeHandler: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value: string;
  options: { displayName: string; id: string; value?: string }[];
  name: string;
  setIsUserInput: (value: ActiveFieldType) => void;
};

export const RadioButton: React.FC<RadioButtonProps> = ({
  eventChangeHandler,
  value,
  options,
  name,
  setIsUserInput,
}) => {
  const handleRedioButtonChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    eventChangeHandler(event);
    setIsUserInput({ key: name, value: event.target.value });
  };

  return (
    <div className="l1-mb-2 l1-flex l1-flex-row l1-items-center l1-gap-6">
      {options.map((option) => (
        <div key={option.id} className="l1-flex l1-items-center l1-gap-2">
          <input
            type="radio"
            id={option.id}
            name={name}
            value={option.value}
            checked={value === option.value}
            onChange={handleRedioButtonChange}
            className="l1-size-4 l1-cursor-pointer l1-accent-[#6E00BE]"
          />
          <label>{option.displayName}</label>
        </div>
      ))}
    </div>
  );
};
